import { ReactNode } from 'react';

type AuthLayoutProps = {
	children: ReactNode;
};

const AuthLayout = ({ children }: AuthLayoutProps) => {
	return (
		<section className="flex h-screen min-h-screen w-full justify-center md:items-center xl:h-[99vh]">
			<div className="flex h-screen w-full max-w-5xl lg:bg-zinc-200/30 xl:h-[99vh]">
				<div className="relative hidden h-screen overflow-hidden bg-[#EFEDD9] md:block md:w-1/2 lg:rounded-s-sm xl:h-[99vh]">
					<img
						src="https://res.cloudinary.com/dd5pbp2tb/image/upload/v1770053580/image.jpg_wyf9vl.png"
						className="absolute h-full w-full object-contain object-center"
						alt="Bem-vindo ao Plumaa"
					/>
				</div>

				{children}
			</div>
		</section>
	);
};

export { AuthLayout };
